<template>
     <router-view  :platInfo="platInfo"></router-view>

 
  
</template>

<script>
import { ref,getCurrentInstance,onMounted,computed,onBeforeUnmount } from 'vue'
import ScaleBox from "./components/ScaleBox.vue"
import floatingWidget from "./components/floatingWidget.vue"
import { useRoute } from 'vue-router'          // 新增
export default {
  name: "App",
  components: {ScaleBox,floatingWidget},
  setup() {

    const {proxy}=getCurrentInstance();
    const route = useRoute();
    // 动态更改favicon
    const floatShow = ref(proxy.getConfig().floatShow)
    const changeFavicon = (src) => {
      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = src;
    };
    //  const configFloatShow = ref(proxy.getConfig().floatShow);
     const configFloatShow = computed(() => {
      // 如果当前路由路径包含 '/h5'（可根据实际调整），则隐藏
      if (route.path.includes('/h5')) {
        return false;
      }
      // 否则遵循配置
      return floatShow.value;
    });

    //获取门户信息
    // const getPortalInfo = () => {
    //   proxy
    //     .$request({
    //       url: "INDUSTRYMANGE_FINDDEFAULT",
    //       method: "post",
    //     })
    //     .then((res) => {
    //       if (res.data.code == "000") {
    //         let result = res.data.result;
    //         store.commit("setTheme", result.theme);
    //         store.commit("setModule", result.module);
    //         store.commit("setPortalInfo",result);
    //         changeFavicon(proxy.commenUrl + result.browserIcon);
    //         document.title = result.browserName;
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // };
    // getPortalInfo();
    //获取屏幕尺寸
    // 防抖函数
    const debounceTimeout = ref(null)
    const debounceResize = () => {
        if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
        debounceTimeout.value = setTimeout(() => {
            calculateHeight();
        }, 200);
    };

    const windowWidth = ref(window.innerWidth)
    const calculateHeight = () => {
        windowWidth.value = window.innerWidth;
    };
    const isMobile = computed(() => {
      console.log(windowWidth.value,'宽度')
      return windowWidth.value < 768;
    });
       const platInfo = ref({})
    //获取门户信息
    const getPortalInfo = () => {
      proxy
        .$request({
          url: "PROTAL_N_INDUSTRYMANGE_FINDDEFAULTBYTYPE",
          data: {
            portalType: "nfstzx"
          },
          method: "post",
        })
        .then((res) => {
          if (res.data.code == "000") {
            let result = res.data.result;
            changeFavicon(proxy.commenUrl + result.browserIcon);
            document.title = result.browserName;
            platInfo.value.tradeImg = res.data.result.tradeImg
            platInfo.value.gzh = res.data.result.gzh
            platInfo.value.tel = res.data.result.tel
            platInfo.value.logo = res.data.result.logo
            console.log(platInfo.value,'platInfo')
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getPortalInfo()
    onMounted(() => {
        calculateHeight();
        window.addEventListener('resize', debounceResize);
    })
    onBeforeUnmount(() => {
        window.removeEventListener('resize', debounceResize);
    })
    return{
      isMobile,
      floatShow,
      platInfo,
      configFloatShow
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* min-width: 1400px; */
  font-size: 14px;
}
body {
  margin: 0 !important;
  padding: 0;
  background-color: #f7f8fa;
}
body,
html {
  width: 100%;
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
}
</style>
